import React from 'react'
import AnimateImageThree from './AnimateImageThree'
import AnimateTitleThree from './AnimatedTitleThree'

const TailoringUnit = () => {
    return (
        <section className='section-tailoring-unit section-padding' id='tailoring-unit'>
            <div className='container'>
                <div className='row'>
                <div className='col-md-8 offset-md-2'>
                    <div className='section-img-heading'>
                        <div className='section-title'>
                        <AnimateTitleThree/>
                     </div>
                    <div className='animated-image-wrapper'>
                        <AnimateImageThree/>
                    </div>
                    </div>
                   <div className='section-content-wrapper'>
                     <div className='section-paragraph'>
                        <p>Our tailoring division houses experienced pattern makers and master tailors who bring structure to artistry. Precision cutting, fine stitching, and expert assembly ensure that each embroidered panel transforms into a garment of impeccable silhouette and finish. This synergy between embroidery and tailoring defines the finesse that our clients associate with us.</p>
                     </div>
                   </div>
                </div>
                </div>
            </div>
        </section>
    )
}

export default TailoringUnit